import React, { Fragment, useEffect, useState } from 'react'
import { StandardPage } from '../../components/_EOS/StandardPage'
import {
  GenericOrderBy,
  GenericTable,
  getNewDirection
} from '../../components/_EOS/Table'
import { Filter, FilterComponent } from '../../components/_WMS/FilterComponent'
import { ApiResponse } from '../../typings/ApiResponse'
import { ProductOrigin } from '../../interfaces/Producto/ProductOrigins'
import { useApi } from '../../hooks/useApi'
import { usePagination } from '../../hooks/usePagination'
import { useModal } from '../../hooks/useModal'
import { useSnackbar } from '../../hooks/useSnackbar'
import { SnackBar } from '../../components/SnackBar/Snackbar'
import { ProductOriginModal } from './Modal/ProductOriginModal'
import { filterOptions, headersConfig } from './Config/config'
import { getProductsOrigins } from './api'
import { Box, IconButton, Tooltip, Typography } from '@mui/material'
import { Edit as EditIcon } from '@mui/icons-material'
import FlipCameraAndroidIcon from '@mui/icons-material/FlipCameraAndroid'
import { Modal } from '../../components/_EOS/Modal'
import { Status } from '../../hooks/useFetchState'

interface ProductOriginPageProps {}

export const ProductOriginPage: React.FC<ProductOriginPageProps> = () => {
  const activarBotonSync = false // se crea variable para ocultar boton sincronizar hasta que se determine si aprueban que puede ir.
  const pagination = usePagination(5)
  const { isOpen, closeModal, size, title, openModal, extendedProps } =
    useModal<ProductOrigin>('Actualizar Marca')

  const {
    isOpen: isOpenConfirm,
    closeModal: closeModalConfirm,
    title: titleConfirm,
    openModal: openModalConfirm,
    extendedProps: extendedPropsv2
  } = useModal<ProductOrigin>('Confirmar')

  const { isActive, isSuccess, openSnackBar, message } = useSnackbar()
  const [searchFilters, setSearchFilters] = React.useState<Filter[]>([])

  const { state, callApi } = useApi<ApiResponse<ProductOrigin>>()

  const requestProductOrigins = (
    f: Filter[],
    page: number,
    pageSize: number
  ) => {
    callApi(getProductsOrigins(f, orderBy, page, pageSize))
  }

  const handleCloseModalMessage = (success: boolean, message: string) => {
    openSnackBar(message, success)
    if (success) {
      closeModal()
      requestProductOrigins(searchFilters, 0, pagination.pageSize)
    }
  }

  const [orderBy, setOrderBy] = useState<GenericOrderBy<ProductOrigin>>({
    field: 'productOriginId',
    direction: 'asc'
  })
  const handleSorting = ({
    field,
    direction
  }: GenericOrderBy<ProductOrigin>) => {
    if (field === orderBy.field) {
      const newDirection = getNewDirection(orderBy.direction)
      setOrderBy((prev) => ({ ...prev, direction: newDirection }))
      return
    }

    setOrderBy({ field, direction })
  }

  const handlePaginationChange = (page: number, pageSize: number) => {
    // If the pageSize is different, we should set page 0
    const auxPage = pagination.pageSize !== pageSize ? 0 : page

    requestProductOrigins(searchFilters, auxPage, pageSize)
    pagination.setPagination(auxPage, pageSize)
  }

  useEffect(() => {
    pagination.setPagination(0, pagination.pageSize)

    requestProductOrigins(searchFilters, 0, pagination.pageSize)
  }, [searchFilters, orderBy, pagination.pageSize])

  type CustomActionsProps = {
    id: number
    row: ProductOrigin
  }

  const MyCustomActions: React.FC<CustomActionsProps> = ({ row }) => {
    return (
      <Fragment>
        <Tooltip title='Editar' aria-label='edit'>
          <IconButton
            aria-label='seeBinacle'
            onClick={() => {
              openModal('md', row)
            }}
            style={{ verticalAlign: 'bottom' }}
            disabled={false}
          >
            <EditIcon />
          </IconButton>
        </Tooltip>
        {activarBotonSync && (
          <Tooltip title='Sincronizar Catálogo Marcas' aria-label='edit'>
            <IconButton
              aria-label='seeBinacle'
              onClick={() => {
                openModalConfirm('xs', row)
              }}
              style={{ verticalAlign: 'bottom' }}
              disabled={false}
            >
              <FlipCameraAndroidIcon />
            </IconButton>
          </Tooltip>
        )}
      </Fragment>
    )
  }

  return (
    <Fragment>
      <StandardPage pageTitle=''>
        <FilterComponent
          options={filterOptions}
          onSearchClick={(filters: Filter[]) =>
            requestProductOrigins(filters, 0, pagination.pageSize)
          }
          selectedFilters={searchFilters}
          setSelectedFilters={setSearchFilters}
          onAddButtonClick={() => openModal('md')}
          createButtonTooltip='Crear Marca'
        />
        <Box>
          <GenericTable<ProductOrigin>
            isLoading={state.status === Status.Loading}
            customActionComponent={MyCustomActions}
            headersConfig={headersConfig}
            IDKey={'productOriginId'}
            data={state.data?.items}
            pagination={{
              page: pagination.page,
              pageSize: pagination.pageSize,
              totalItem: state.data?.totalItems || 0
            }}
            onPaginationChange={handlePaginationChange}
            onSortChange={handleSorting}
          />
        </Box>
      </StandardPage>

      <ProductOriginModal
        isOpen={isOpen}
        size={size}
        title={title}
        closeModal={closeModal}
        extendedProps={extendedProps}
        handleCloseModalMessage={handleCloseModalMessage}
        editMode={
          extendedProps !== undefined && extendedProps?.productOriginId > 0
        }
      />
      <Modal
        title={titleConfirm}
        onClose={closeModalConfirm}
        open={isOpenConfirm}
        maxWidth='xs'
        successButton={{
          action: () => alert(extendedPropsv2?.productOriginId),
          title: 'Aceptar'
        }}
        cancelButton={{
          action: closeModalConfirm,
          title: 'Cancelar'
        }}
      >
        <Typography variant='body2'>
          Se sincronizaran los productos de la marca seleccionada
        </Typography>
      </Modal>
      <SnackBar
        open={isActive}
        message={message}
        status={isSuccess ? 'success' : 'error'}
      />
    </Fragment>
  )
}
